module.exports = __webpack_public_path__ + "assets/img/icon3.8e8047b0.png";